import { render, staticRenderFns } from "./agv-content-block.vue?vue&type=template&id=6241ef9e&scoped=true&lang=pug&"
import script from "./agv-content-block.vue?vue&type=script&lang=js&"
export * from "./agv-content-block.vue?vue&type=script&lang=js&"
import style0 from "./agv-content-block.vue?vue&type=style&index=0&id=6241ef9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6241ef9e",
  null
  
)

export default component.exports